import { useParams, Link } from "react-router-dom";
import servicesData from "../data/servicesData";

export default function ServiceDetail() {
  const { slug } = useParams();

  const service = servicesData[slug];

  if (!service) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6">
        <h1 className="text-3xl font-bold mb-4">Service Not Found</h1>

        <Link
          to="/services"
          className="px-6 py-3 rounded-full bg-black text-white"
        >
          Back to Services
        </Link>
      </div>
    );
  }

  return (
    <main className="bg-gradient-to-b from-[#a78bfa] via-[#e6e0ff] to-white">

      {/* HERO */}
      <section className="max-w-6xl mx-auto px-6 pt-12 pb-20">
        <div className="bg-purple-800 text-white rounded-3xl px-8 py-16 md:px-12 md:py-24">

          <div className="text-sm text-purple-200 mb-4">
            <Link to="/" className="hover:text-white">
              Home
            </Link>
            {" > "}
            <Link to="/services" className="hover:text-white">
              Services
            </Link>
            {" > "}
            {service.title}
          </div>

          <h1 className="text-3xl md:text-5xl font-bold leading-tight">
            {service.title}
          </h1>

          <p className="mt-6 text-lg text-purple-100 max-w-3xl">
            {service.heroDescription}
          </p>
        </div>
      </section>

      {/* OVERVIEW */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm">

          <h2 className="text-3xl font-bold text-black mb-6">
            Service Overview
          </h2>

          <div className="space-y-4 text-gray-700 leading-relaxed">
            {service.overview.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>

        </div>
      </section>

      {/* HOW WE HELP */}
      <section className="max-w-6xl mx-auto px-6 py-8">
        <h2 className="text-3xl font-bold text-black mb-8">
          How We Help
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {service.help.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 border hover:shadow-lg transition"
            >
              <p className="font-medium text-black">
                {item}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* BENEFITS */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-black mb-8">
          Benefits
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {service.benefits.map((item, index) => (
            <div
              key={index}
              className="bg-teal-400 rounded-2xl p-6"
            >
              <p className="font-semibold text-black">
                {item}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-black mb-8">
          Our Process
        </h2>

        <div className="space-y-4">
          {service.process.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 flex items-center gap-4"
            >
              <div className="w-10 h-10 rounded-full bg-purple-800 text-white flex items-center justify-center font-bold">
                {index + 1}
              </div>

              <p className="text-black font-medium">
                {item}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white rounded-3xl p-8 md:p-12">

          <h2 className="text-3xl font-bold text-black mb-8">
            Why Choose Maxzen HR
          </h2>

          <div className="grid md:grid-cols-2 gap-6">
            {service.whyChoose.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-3"
              >
                <div className="w-3 h-3 rounded-full bg-orange-500" />
                <p className="text-gray-700">{item}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="max-w-6xl mx-auto px-6 pb-24">
        <div className="bg-purple-800 rounded-3xl text-center px-8 py-16">

          <h2 className="text-3xl md:text-4xl font-bold text-white">
            {service.cta}
          </h2>

          <p className="mt-4 text-white">
            Talk to our team and discover how Maxzen HR can support your workforce goals.
          </p>

          <Link
            to="/contact"
            className="inline-flex mt-8 px-8 py-3 rounded-full bg-black text-white hover:bg-gray-900 transition"
          >
            Contact Us
          </Link>

        </div>
      </section>

    </main>
  );
}